import React, { useEffect, useRef, useState, useCallback } from 'react';
import BeatList from './BeatList';
import styles from './FavBeatsContent.module.css';
import SearchModal from './SearchModal';
import backIcon from "../icons/back_icn.png";
import searchIcon from "../icons/search_beat.png";
import closeIcon  from '../icons/search_close.png';
import axios from 'axios';

const FavBeatsContent = ({ onBack, isAuthenticated, sendEvent }) => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);
  const [likedBeats, setLikedBeats] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchLikedBeats = useCallback(() => {
    if (isAuthenticated) {
      axios
        .get('/api/favorites/list')
        .then((response) => {
          setLikedBeats(response.data);
        })
        .catch(() => {
        });
    } else {
      setLikedBeats([]);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    fetchLikedBeats();

    window.addEventListener('likedBeatsChanged', fetchLikedBeats);

    return () => {
      window.removeEventListener('likedBeatsChanged', fetchLikedBeats);
    };
  }, [isAuthenticated, fetchLikedBeats]);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;

      const startAutoScroll = () => {
        scrollInterval.current = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval.current);
	    scrollInterval.current = null;
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval.current);
	scrollInterval.current = null;
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      };

      content.addEventListener('wheel', stopAutoScroll, { passive: true });
      content.addEventListener('touchstart', stopAutoScroll, { passive: true });

      return () => {
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
        clearInterval(scrollInterval.current);
      };
    }
  }, []);

  const restartAutoScroll = () => {
    const content = contentRef.current;
    if (!content) return;

    clearInterval(scrollInterval.current);
    scrollInterval.current = null;

    const stop = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel', stop, { passive: true });
      content.removeEventListener('touchstart', stop, { passive: true });
    };

    content.scrollTop = 0;
    let scrollStep = 1;
    scrollInterval.current = setInterval(() => {
      if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
        stop();
      } else {
        content.scrollTop += scrollStep;
      }
    }, 50);

    content.addEventListener('wheel', stop, { passive: true });
    content.addEventListener('touchstart', stop, { passive: true });
  };

  const handleSearchIconClick = () => {
    if (!isAuthenticated) return;
    if (searchQuery) {
        setSearchQuery('');
        if (!scrollInterval.current) {
        restartAutoScroll();
      } else {
        const c = contentRef.current;
        c && c.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      setShowSearch(true);
    }
  };

  return (
    <div className={styles.favBeatsContentContainer}>
        <img
          src={backIcon}
          alt="Back"
          className={`${styles.backIcon} ${styles.visible}`}
          onClick={onBack}
        />

      {isAuthenticated && (
        <img
          src={searchQuery ? closeIcon : searchIcon}
          alt={searchQuery ? 'Clear search' : 'Search'}
          className={`${styles.searchIcon} ${styles.visible}`}
          onClick={handleSearchIconClick}
        />
       )}

        <h1 className={styles.pageTitle}>Fav Beats</h1>

        <div className={styles.favBeatsContent} ref={contentRef}>
          {likedBeats.length > 0 ? (
	   <>
            <BeatList
              propBeats={likedBeats}
              isAuthenticated={isAuthenticated}
              restartAutoScroll={restartAutoScroll}
	      sendEvent={sendEvent}
	      searchQuery={searchQuery}
            />

	     {isAuthenticated && showSearch && (
              <SearchModal
		initialBeats={likedBeats}
                onClose={() => setShowSearch(false)}
                onSubmit={q => {
                 setSearchQuery(q.trim());
                 setShowSearch(false);
              }}
            />
         )}
	</>
      ) : (
        <p className={styles.noFavoritesMessage}>
          {isAuthenticated
            ? "You haven’t liked any beats yet."
            : "Sign In to check out your faves!"}
            </p>
          )}
      </div>
    </div>
  );
};

export default FavBeatsContent;


